module.exports = __webpack_public_path__ + "media/slot-game/diamond-b5edd493.svg";